<template>
  <div @click="updateDisplay" class="my-2 border-2 h-24 shadow-md mx-sm my-xsm px-sm py-xsm flex items-center border-default hover:bg-light-grey hover:shadow-lg justify-around rounded-3xl shadow-sharp cursor-pointer mx-1 w-full font-text">
    <div class="ml-1">
      <img v-if="isImage" class="w-20" alt="Logo" :src="img">
      <Icon v-if="!isImage" class="text-7xl text-default-dark" :icon="[img.split(';')[0], img.split(';')[1]]" />
    </div>
    <div class="flex flex-col w-8/12">
      <p class="flex-grow mx-auto text-2xl text-default">{{ title }}</p>
      <p v-if="title == 'Purdue University'" class="flex-grow mx-auto text-xl text-default">Honors College</p>
      <p class="flex-grow mx-auto text-lg text-default">{{ position }}</p>
    </div>
  </div>
  <div v-if="this.display" @click="updateDisplay" class="z-20 fixed m-auto inset-x-0 inset-y-0 backdrop-filter backdrop-blur-lg bg-opacity-30 bg-dark-grey cursor-pointer overflow-hidden"></div>
  <AchievementPopupMobile v-if="this.display" :title="title" :status="position" :attachmentOne="attachmentOne" :attachmentTwo="attachmentTwo" :desc="desc" :images="images"/>
</template>

<script>
import AchievementPopupMobile from '@/components/mobile/AchievementPopupMobile'

export default {
  name: 'Achievement',
  components: {
    AchievementPopupMobile
  },
  props: {
    title: {
      type: String,
      required: true
    },
    position: {
      type: String,
      required: true
    },
    img: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    attachmentOne: {
      type: Object,
      required: false
    },
    attachmentTwo: {
      type: Object,
      required: false
    },
    desc: {
      type: String,
      required: false
    },
    images: {
      type: Array,
      required: false
    }
  },
  data: function () {
    return {
      isImage: false,
      display: false
    }
  },
  created: function () {
    console.log(this.link)
    console.log(this.images)
    console.log('DESCRIPTION: ' + this.desc)
    if (this.img.split('/')[1] === 'img') {
      this.isImage = true
    } else {
      console.log(this.img.split(';'))
    }
  },
  methods: {
    updateDisplay: function () {
      this.display = !this.display
    }
  }
}
</script>

<style scoped>

</style>
